import { FC } from 'react';

import Editor from '.';

const EditorFormInput: FC<{
  onChange: (data: any) => void;
  value?: string;
  readOnly?: boolean;
  label: string;
}> = ({ onChange, value, readOnly, label }) => {
  if (readOnly) {
    return (
      <div className="mb-1">
        <span className="block text-sm font-medium leading-6 text-gray-900">{label}</span>
        <div className="ql-container ql-snow">
          <div className="ql-editor" dangerouslySetInnerHTML={{ __html: value || '' }} />
        </div>
      </div>
    );
  }

  return (
    <>
      <span className="block text-sm font-medium leading-6 text-gray-900">{label}</span>
      <Editor
        onChange={data => {
          if (onChange) onChange(data);
        }}
        prevData={value}
        readOnly={readOnly}
      />
    </>
  );
};

export default EditorFormInput;
